/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * High level Role of an account.
 * NOTE: For Employers, more specific Roles are defined @see Employers/EmployerRole.cs
 * In the future, we might remove this Enum
 * @export
 */
export const Role = {
    Employer: 'Employer',
    OnboardingEmployer: 'OnboardingEmployer',
    User: 'User',
    OnboardingUser: 'OnboardingUser',
    None: 'None',
    Visitor: 'Visitor'
};
export function instanceOfRole(value) {
    for (const key in Role) {
        if (Object.prototype.hasOwnProperty.call(Role, key)) {
            if (Role[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function RoleFromJSON(json) {
    return RoleFromJSONTyped(json, false);
}
export function RoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RoleToJSON(value) {
    return value;
}
export function RoleToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
